/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as MedicalTokenRouteImport } from './routes/medical.$token'
import { Route as AuthenticatedMyMissionsRouteImport } from './routes/_authenticated/my-missions'
import { Route as AuthenticatedMyAvailabilityRouteImport } from './routes/_authenticated/my-availability'
import { Route as AuthenticatedMissionsRouteImport } from './routes/_authenticated/missions'
import { Route as AuthenticatedMedicalRouteImport } from './routes/_authenticated/medical'
import { Route as AuthenticatedAvailabilityRouteImport } from './routes/_authenticated/availability'
import { Route as AuthenticatedAiCostsRouteImport } from './routes/_authenticated/ai-costs'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authDoctorSignupAwaitingApprovalRouteImport } from './routes/(auth)/doctor-signup-awaiting-approval'
import { Route as authDoctorSignupRouteImport } from './routes/(auth)/doctor-signup'
import { Route as authAdminSignupRouteImport } from './routes/(auth)/admin-signup'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTechniciansIndexRouteImport } from './routes/_authenticated/technicians/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedPricingIndexRouteImport } from './routes/_authenticated/pricing/index'
import { Route as AuthenticatedPaymentsIndexRouteImport } from './routes/_authenticated/payments/index'
import { Route as AuthenticatedMedicationsIndexRouteImport } from './routes/_authenticated/medications/index'
import { Route as AuthenticatedMedicationAlertsIndexRouteImport } from './routes/_authenticated/medication-alerts/index'
import { Route as AuthenticatedMedicalReferencesIndexRouteImport } from './routes/_authenticated/medical-references/index'
import { Route as AuthenticatedIssueReportsIndexRouteImport } from './routes/_authenticated/issue-reports/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedDocumentTaxonomyIndexRouteImport } from './routes/_authenticated/document-taxonomy/index'
import { Route as AuthenticatedDoctorsIndexRouteImport } from './routes/_authenticated/doctors/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedBloodGroupReviewIndexRouteImport } from './routes/_authenticated/blood-group-review/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAppointmentsIndexRouteImport } from './routes/_authenticated/appointments/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedDocumentsValidationRouteImport } from './routes/_authenticated/documents.validation'

const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const MedicalTokenRoute = MedicalTokenRouteImport.update({
  id: '/medical/$token',
  path: '/medical/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedMyMissionsRoute = AuthenticatedMyMissionsRouteImport.update({
  id: '/my-missions',
  path: '/my-missions',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMyAvailabilityRoute =
  AuthenticatedMyAvailabilityRouteImport.update({
    id: '/my-availability',
    path: '/my-availability',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMissionsRoute = AuthenticatedMissionsRouteImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMedicalRoute = AuthenticatedMedicalRouteImport.update({
  id: '/medical',
  path: '/medical',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAvailabilityRoute =
  AuthenticatedAvailabilityRouteImport.update({
    id: '/availability',
    path: '/availability',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAiCostsRoute = AuthenticatedAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authDoctorSignupAwaitingApprovalRoute =
  authDoctorSignupAwaitingApprovalRouteImport.update({
    id: '/(auth)/doctor-signup-awaiting-approval',
    path: '/doctor-signup-awaiting-approval',
    getParentRoute: () => rootRouteImport,
  } as any)
const authDoctorSignupRoute = authDoctorSignupRouteImport.update({
  id: '/(auth)/doctor-signup',
  path: '/doctor-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const authAdminSignupRoute = authAdminSignupRouteImport.update({
  id: '/(auth)/admin-signup',
  path: '/admin-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTechniciansIndexRoute =
  AuthenticatedTechniciansIndexRouteImport.update({
    id: '/technicians/',
    path: '/technicians/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedPricingIndexRoute =
  AuthenticatedPricingIndexRouteImport.update({
    id: '/pricing/',
    path: '/pricing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPaymentsIndexRoute =
  AuthenticatedPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMedicationsIndexRoute =
  AuthenticatedMedicationsIndexRouteImport.update({
    id: '/medications/',
    path: '/medications/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMedicationAlertsIndexRoute =
  AuthenticatedMedicationAlertsIndexRouteImport.update({
    id: '/medication-alerts/',
    path: '/medication-alerts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMedicalReferencesIndexRoute =
  AuthenticatedMedicalReferencesIndexRouteImport.update({
    id: '/medical-references/',
    path: '/medical-references/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIssueReportsIndexRoute =
  AuthenticatedIssueReportsIndexRouteImport.update({
    id: '/issue-reports/',
    path: '/issue-reports/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentTaxonomyIndexRoute =
  AuthenticatedDocumentTaxonomyIndexRouteImport.update({
    id: '/document-taxonomy/',
    path: '/document-taxonomy/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsIndexRoute =
  AuthenticatedDoctorsIndexRouteImport.update({
    id: '/doctors/',
    path: '/doctors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBloodGroupReviewIndexRoute =
  AuthenticatedBloodGroupReviewIndexRouteImport.update({
    id: '/blood-group-review/',
    path: '/blood-group-review/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAppointmentsIndexRoute =
  AuthenticatedAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentsValidationRoute =
  AuthenticatedDocumentsValidationRouteImport.update({
    id: '/documents/validation',
    path: '/documents/validation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/admin-signup': typeof authAdminSignupRoute
  '/doctor-signup': typeof authDoctorSignupRoute
  '/doctor-signup-awaiting-approval': typeof authDoctorSignupAwaitingApprovalRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/ai-costs': typeof AuthenticatedAiCostsRoute
  '/availability': typeof AuthenticatedAvailabilityRoute
  '/medical': typeof AuthenticatedMedicalRoute
  '/missions': typeof AuthenticatedMissionsRoute
  '/my-availability': typeof AuthenticatedMyAvailabilityRoute
  '/my-missions': typeof AuthenticatedMyMissionsRoute
  '/medical/$token': typeof MedicalTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/documents/validation': typeof AuthenticatedDocumentsValidationRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/blood-group-review': typeof AuthenticatedBloodGroupReviewIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/doctors': typeof AuthenticatedDoctorsIndexRoute
  '/document-taxonomy': typeof AuthenticatedDocumentTaxonomyIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/issue-reports': typeof AuthenticatedIssueReportsIndexRoute
  '/medical-references': typeof AuthenticatedMedicalReferencesIndexRoute
  '/medication-alerts': typeof AuthenticatedMedicationAlertsIndexRoute
  '/medications': typeof AuthenticatedMedicationsIndexRoute
  '/payments': typeof AuthenticatedPaymentsIndexRoute
  '/pricing': typeof AuthenticatedPricingIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/technicians': typeof AuthenticatedTechniciansIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/admin-signup': typeof authAdminSignupRoute
  '/doctor-signup': typeof authDoctorSignupRoute
  '/doctor-signup-awaiting-approval': typeof authDoctorSignupAwaitingApprovalRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/ai-costs': typeof AuthenticatedAiCostsRoute
  '/availability': typeof AuthenticatedAvailabilityRoute
  '/medical': typeof AuthenticatedMedicalRoute
  '/missions': typeof AuthenticatedMissionsRoute
  '/my-availability': typeof AuthenticatedMyAvailabilityRoute
  '/my-missions': typeof AuthenticatedMyMissionsRoute
  '/medical/$token': typeof MedicalTokenRoute
  '/': typeof AuthenticatedIndexRoute
  '/documents/validation': typeof AuthenticatedDocumentsValidationRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/blood-group-review': typeof AuthenticatedBloodGroupReviewIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/doctors': typeof AuthenticatedDoctorsIndexRoute
  '/document-taxonomy': typeof AuthenticatedDocumentTaxonomyIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/issue-reports': typeof AuthenticatedIssueReportsIndexRoute
  '/medical-references': typeof AuthenticatedMedicalReferencesIndexRoute
  '/medication-alerts': typeof AuthenticatedMedicationAlertsIndexRoute
  '/medications': typeof AuthenticatedMedicationsIndexRoute
  '/payments': typeof AuthenticatedPaymentsIndexRoute
  '/pricing': typeof AuthenticatedPricingIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/technicians': typeof AuthenticatedTechniciansIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/admin-signup': typeof authAdminSignupRoute
  '/(auth)/doctor-signup': typeof authDoctorSignupRoute
  '/(auth)/doctor-signup-awaiting-approval': typeof authDoctorSignupAwaitingApprovalRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/ai-costs': typeof AuthenticatedAiCostsRoute
  '/_authenticated/availability': typeof AuthenticatedAvailabilityRoute
  '/_authenticated/medical': typeof AuthenticatedMedicalRoute
  '/_authenticated/missions': typeof AuthenticatedMissionsRoute
  '/_authenticated/my-availability': typeof AuthenticatedMyAvailabilityRoute
  '/_authenticated/my-missions': typeof AuthenticatedMyMissionsRoute
  '/medical/$token': typeof MedicalTokenRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/documents/validation': typeof AuthenticatedDocumentsValidationRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/blood-group-review/': typeof AuthenticatedBloodGroupReviewIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/doctors/': typeof AuthenticatedDoctorsIndexRoute
  '/_authenticated/document-taxonomy/': typeof AuthenticatedDocumentTaxonomyIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/issue-reports/': typeof AuthenticatedIssueReportsIndexRoute
  '/_authenticated/medical-references/': typeof AuthenticatedMedicalReferencesIndexRoute
  '/_authenticated/medication-alerts/': typeof AuthenticatedMedicationAlertsIndexRoute
  '/_authenticated/medications/': typeof AuthenticatedMedicationsIndexRoute
  '/_authenticated/payments/': typeof AuthenticatedPaymentsIndexRoute
  '/_authenticated/pricing/': typeof AuthenticatedPricingIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/technicians/': typeof AuthenticatedTechniciansIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clerk'
    | '/settings'
    | '/admin-signup'
    | '/doctor-signup'
    | '/doctor-signup-awaiting-approval'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/ai-costs'
    | '/availability'
    | '/medical'
    | '/missions'
    | '/my-availability'
    | '/my-missions'
    | '/medical/$token'
    | '/'
    | '/documents/validation'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/analytics'
    | '/appointments'
    | '/apps'
    | '/blood-group-review'
    | '/chats'
    | '/doctors'
    | '/document-taxonomy'
    | '/help-center'
    | '/issue-reports'
    | '/medical-references'
    | '/medication-alerts'
    | '/medications'
    | '/payments'
    | '/pricing'
    | '/settings/'
    | '/tasks'
    | '/technicians'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/admin-signup'
    | '/doctor-signup'
    | '/doctor-signup-awaiting-approval'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/ai-costs'
    | '/availability'
    | '/medical'
    | '/missions'
    | '/my-availability'
    | '/my-missions'
    | '/medical/$token'
    | '/'
    | '/documents/validation'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/analytics'
    | '/appointments'
    | '/apps'
    | '/blood-group-review'
    | '/chats'
    | '/doctors'
    | '/document-taxonomy'
    | '/help-center'
    | '/issue-reports'
    | '/medical-references'
    | '/medication-alerts'
    | '/medications'
    | '/payments'
    | '/pricing'
    | '/settings'
    | '/tasks'
    | '/technicians'
    | '/users'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/admin-signup'
    | '/(auth)/doctor-signup'
    | '/(auth)/doctor-signup-awaiting-approval'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/ai-costs'
    | '/_authenticated/availability'
    | '/_authenticated/medical'
    | '/_authenticated/missions'
    | '/_authenticated/my-availability'
    | '/_authenticated/my-missions'
    | '/medical/$token'
    | '/_authenticated/'
    | '/_authenticated/documents/validation'
    | '/_authenticated/errors/$error'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/analytics/'
    | '/_authenticated/appointments/'
    | '/_authenticated/apps/'
    | '/_authenticated/blood-group-review/'
    | '/_authenticated/chats/'
    | '/_authenticated/doctors/'
    | '/_authenticated/document-taxonomy/'
    | '/_authenticated/help-center/'
    | '/_authenticated/issue-reports/'
    | '/_authenticated/medical-references/'
    | '/_authenticated/medication-alerts/'
    | '/_authenticated/medications/'
    | '/_authenticated/payments/'
    | '/_authenticated/pricing/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/technicians/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  authAdminSignupRoute: typeof authAdminSignupRoute
  authDoctorSignupRoute: typeof authDoctorSignupRoute
  authDoctorSignupAwaitingApprovalRoute: typeof authDoctorSignupAwaitingApprovalRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  MedicalTokenRoute: typeof MedicalTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/medical/$token': {
      id: '/medical/$token'
      path: '/medical/$token'
      fullPath: '/medical/$token'
      preLoaderRoute: typeof MedicalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/my-missions': {
      id: '/_authenticated/my-missions'
      path: '/my-missions'
      fullPath: '/my-missions'
      preLoaderRoute: typeof AuthenticatedMyMissionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-availability': {
      id: '/_authenticated/my-availability'
      path: '/my-availability'
      fullPath: '/my-availability'
      preLoaderRoute: typeof AuthenticatedMyAvailabilityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/missions': {
      id: '/_authenticated/missions'
      path: '/missions'
      fullPath: '/missions'
      preLoaderRoute: typeof AuthenticatedMissionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medical': {
      id: '/_authenticated/medical'
      path: '/medical'
      fullPath: '/medical'
      preLoaderRoute: typeof AuthenticatedMedicalRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/availability': {
      id: '/_authenticated/availability'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AuthenticatedAvailabilityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ai-costs': {
      id: '/_authenticated/ai-costs'
      path: '/ai-costs'
      fullPath: '/ai-costs'
      preLoaderRoute: typeof AuthenticatedAiCostsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/doctor-signup-awaiting-approval': {
      id: '/(auth)/doctor-signup-awaiting-approval'
      path: '/doctor-signup-awaiting-approval'
      fullPath: '/doctor-signup-awaiting-approval'
      preLoaderRoute: typeof authDoctorSignupAwaitingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/doctor-signup': {
      id: '/(auth)/doctor-signup'
      path: '/doctor-signup'
      fullPath: '/doctor-signup'
      preLoaderRoute: typeof authDoctorSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/admin-signup': {
      id: '/(auth)/admin-signup'
      path: '/admin-signup'
      fullPath: '/admin-signup'
      preLoaderRoute: typeof authAdminSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/technicians/': {
      id: '/_authenticated/technicians/'
      path: '/technicians'
      fullPath: '/technicians'
      preLoaderRoute: typeof AuthenticatedTechniciansIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/pricing/': {
      id: '/_authenticated/pricing/'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AuthenticatedPricingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/payments/': {
      id: '/_authenticated/payments/'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthenticatedPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medications/': {
      id: '/_authenticated/medications/'
      path: '/medications'
      fullPath: '/medications'
      preLoaderRoute: typeof AuthenticatedMedicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medication-alerts/': {
      id: '/_authenticated/medication-alerts/'
      path: '/medication-alerts'
      fullPath: '/medication-alerts'
      preLoaderRoute: typeof AuthenticatedMedicationAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medical-references/': {
      id: '/_authenticated/medical-references/'
      path: '/medical-references'
      fullPath: '/medical-references'
      preLoaderRoute: typeof AuthenticatedMedicalReferencesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/issue-reports/': {
      id: '/_authenticated/issue-reports/'
      path: '/issue-reports'
      fullPath: '/issue-reports'
      preLoaderRoute: typeof AuthenticatedIssueReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/document-taxonomy/': {
      id: '/_authenticated/document-taxonomy/'
      path: '/document-taxonomy'
      fullPath: '/document-taxonomy'
      preLoaderRoute: typeof AuthenticatedDocumentTaxonomyIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/': {
      id: '/_authenticated/doctors/'
      path: '/doctors'
      fullPath: '/doctors'
      preLoaderRoute: typeof AuthenticatedDoctorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blood-group-review/': {
      id: '/_authenticated/blood-group-review/'
      path: '/blood-group-review'
      fullPath: '/blood-group-review'
      preLoaderRoute: typeof AuthenticatedBloodGroupReviewIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/appointments/': {
      id: '/_authenticated/appointments/'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documents/validation': {
      id: '/_authenticated/documents/validation'
      path: '/documents/validation'
      fullPath: '/documents/validation'
      preLoaderRoute: typeof AuthenticatedDocumentsValidationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedAiCostsRoute: typeof AuthenticatedAiCostsRoute
  AuthenticatedAvailabilityRoute: typeof AuthenticatedAvailabilityRoute
  AuthenticatedMedicalRoute: typeof AuthenticatedMedicalRoute
  AuthenticatedMissionsRoute: typeof AuthenticatedMissionsRoute
  AuthenticatedMyAvailabilityRoute: typeof AuthenticatedMyAvailabilityRoute
  AuthenticatedMyMissionsRoute: typeof AuthenticatedMyMissionsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDocumentsValidationRoute: typeof AuthenticatedDocumentsValidationRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
  AuthenticatedAppointmentsIndexRoute: typeof AuthenticatedAppointmentsIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedBloodGroupReviewIndexRoute: typeof AuthenticatedBloodGroupReviewIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedDoctorsIndexRoute: typeof AuthenticatedDoctorsIndexRoute
  AuthenticatedDocumentTaxonomyIndexRoute: typeof AuthenticatedDocumentTaxonomyIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedIssueReportsIndexRoute: typeof AuthenticatedIssueReportsIndexRoute
  AuthenticatedMedicalReferencesIndexRoute: typeof AuthenticatedMedicalReferencesIndexRoute
  AuthenticatedMedicationAlertsIndexRoute: typeof AuthenticatedMedicationAlertsIndexRoute
  AuthenticatedMedicationsIndexRoute: typeof AuthenticatedMedicationsIndexRoute
  AuthenticatedPaymentsIndexRoute: typeof AuthenticatedPaymentsIndexRoute
  AuthenticatedPricingIndexRoute: typeof AuthenticatedPricingIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTechniciansIndexRoute: typeof AuthenticatedTechniciansIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedAiCostsRoute: AuthenticatedAiCostsRoute,
  AuthenticatedAvailabilityRoute: AuthenticatedAvailabilityRoute,
  AuthenticatedMedicalRoute: AuthenticatedMedicalRoute,
  AuthenticatedMissionsRoute: AuthenticatedMissionsRoute,
  AuthenticatedMyAvailabilityRoute: AuthenticatedMyAvailabilityRoute,
  AuthenticatedMyMissionsRoute: AuthenticatedMyMissionsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDocumentsValidationRoute: AuthenticatedDocumentsValidationRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  AuthenticatedAppointmentsIndexRoute: AuthenticatedAppointmentsIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedBloodGroupReviewIndexRoute:
    AuthenticatedBloodGroupReviewIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedDoctorsIndexRoute: AuthenticatedDoctorsIndexRoute,
  AuthenticatedDocumentTaxonomyIndexRoute:
    AuthenticatedDocumentTaxonomyIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedIssueReportsIndexRoute: AuthenticatedIssueReportsIndexRoute,
  AuthenticatedMedicalReferencesIndexRoute:
    AuthenticatedMedicalReferencesIndexRoute,
  AuthenticatedMedicationAlertsIndexRoute:
    AuthenticatedMedicationAlertsIndexRoute,
  AuthenticatedMedicationsIndexRoute: AuthenticatedMedicationsIndexRoute,
  AuthenticatedPaymentsIndexRoute: AuthenticatedPaymentsIndexRoute,
  AuthenticatedPricingIndexRoute: AuthenticatedPricingIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTechniciansIndexRoute: AuthenticatedTechniciansIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  authAdminSignupRoute: authAdminSignupRoute,
  authDoctorSignupRoute: authDoctorSignupRoute,
  authDoctorSignupAwaitingApprovalRoute: authDoctorSignupAwaitingApprovalRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  MedicalTokenRoute: MedicalTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
